import * as React from 'react';
import { useState } from 'react';
import {SpaceBetween, tk, Typography, Icon, Button} from '@sunwebgroup/ui-components';
import { CarsListView } from './CarsListView';
import {styled} from 'styled-components';
import {useIntl} from '@/intl';
import { createCarEvent } from '../../../domain/analytics';
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks';

export function ExtraCarsView({ maxNumbersOfCarsToBeBooked }: { maxNumbersOfCarsToBeBooked: number; }) {
  const intl = useIntl();
  const { sendEvent } = useAnalytics();
  const [showCars, setShowCars] = useState<boolean>(false);

  const onAddBtnClick = () => {
    setShowCars(true);
    sendEvent(
      createCarEvent({
        result: 'extra list shown',
        type: 'extra car',
        description: 'Add extra car clicked',
        element: 'button',
      })
    )
  };

  if (maxNumbersOfCarsToBeBooked <= 1) return null;

  return (
    <AddExtraCarsDiv direction="y" spacing={tk('spacing_sm')}>
      {showCars && <CarsListView />}
      {!showCars && (
        <SpaceBetween direction="y" spacing={tk('spacing_sm')}>
          <AddExtraCarsButton $hierarchy="secondary" onClick={onAddBtnClick}>
            <Icon glyph="IconPlus" />
            {intl.formatMessage({ id: 'checkout_steps_ancillaries_car_rental_extra_cars_add_button' })}
          </AddExtraCarsButton>
          <Typography $variant="body-sm">{intl.formatMessage({ id: 'checkout_steps_ancillaries_car_rental_extra_cars_description' }, {max: maxNumbersOfCarsToBeBooked})}</Typography>
        </SpaceBetween>
      )}
    </AddExtraCarsDiv>
  );
}

export const AddExtraCarsDiv = styled(SpaceBetween)`
  padding-top: ${tk('spacing_sm')};
  border-top: 2px solid ${tk('color_semantic_border_subdued')};
`;
export const AddExtraCarsButton = styled(Button)`
  width: fit-content;
`;
